export default [
    {
        title: 'پنل آقای ساعتی',
        icon: 'SendIcon',
        children: [
            {
                title: 'لیست',
                icon: 'SendIcon',
                route: 'Old_Panel_List',
                permission: 'oldData',
            },

        ],
    },
]
